// extracted by mini-css-extract-plugin
export default {"wishlist":"Favourites_wishlist__Gwgb7","wishlist__loader":"Favourites_wishlist__loader__Jph8d","wishlist__body":"Favourites_wishlist__body__Jm6Z7"};